<template>
    <multiselect
        v-model="proxyValue"
        label="title"
        track-by="title"
        :placeholder="$word.type_to_search"
        :options="places"
        :multiple="false"
        :searchable="true"
        select-label=""
        deselect-label=""
        selected-label=""
        :internal-search="true"
        :max-height="600"
        :show-no-results="true"
        :loading="loading"
        @search-change="search"
    >
        <span slot="noResult">{{$text.no_elements_found}}</span>
        <span slot="noOptions">{{$text.enter_something_for_suggestion}}</span>
    </multiselect>
</template>
<script>
    import Multiselect from 'vue-multiselect'

    export default {
        components: {Multiselect},
        props: {
            value: {},
        },
        data: v => ({
            places: [],
            loading: false,
            query: '',
        }),
        computed: {
            proxyValue: {
                get() {
                    return this.value
                },
                set(option) {
                    this.$emit('input', option)
                }
            }
        },
        created() {
            this.doSearch = _.debounce(() => {
                this.loading = true
                axios.get("/places/search/" + this.query)
                    .then(resp => {
                        resp.data.places !== undefined && (this.places = resp.data.places)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },500)
        },
        methods: {
            search(query) {
                this.query = query
                this.doSearch()
            }
        },
    }
</script>
